<template>
	<div class="container">
		<div class="tree-container">
			<div style="padding: 10px;text-align: center">
				<el-button type="primary" icon="el-icon-refresh" circle @click="refreshTree"></el-button>
			</div>

			<el-tree :props="props"
					 :data="menus"
					 :load="loadMenu"
					 @node-click="handleNodeClick"
			>
			</el-tree>
		</div>
		<div class="edit-container">
			<div class="handle-box">
				<el-input v-model="query.name" style="width: 200px;margin-right: 5px;" placeholder="名称" class="handle-input mr10"></el-input>
				<el-button type="primary" icon="el-icon-search" @click="search()">搜索</el-button>

			</div>
			<div style="display: flex;margin-top: 10px;margin-bottom: 10px;">
				<el-button type="primary" @click="add">添加</el-button>
				<el-button type="primary" @click="edit">修改</el-button>
				<el-button type="primary" @click="del">删除</el-button>
			</div>
			<el-table
					:data="queryMenus"
					row-key="id"
					border
					highlight-current-row
					@current-change="handleCurrentChange"
			>
				<el-table-column
						prop="sysName"
						label="所属系统"
				>
				</el-table-column>
				<el-table-column
						prop="name"
						label="名称"
				>
				</el-table-column>
				<el-table-column
						prop="parentName"
						label="父级"
				>
				</el-table-column>
				<el-table-column
						prop="url"
						label="地址">
					<template slot-scope="scope">
						<div v-if="scope.row.url" style="display: flex;flex-direction: column">
							<span  v-for="item in scope.row.url.split(',')">
							{{item}}
							</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column
						prop="type"
						label="菜单类型">
					<template  slot-scope="scope">
						<span v-if="scope.row.type==1">菜单</span>
						<span v-else>操作</span>
					</template>
				</el-table-column>
				<el-table-column
						prop="vueComponent"
						label="component路径">
				</el-table-column>
				<el-table-column
						prop="componentName"
						label="component名称">
				</el-table-column>
				<el-table-column
						prop="sort"
						label="排序">
				</el-table-column>
				<el-table-column
						prop="icon"
						label="图标">
				</el-table-column>
				<el-table-column
						prop="level"
						label="层级">
				</el-table-column>
				<el-table-column
						prop="showMenu"
						label="是否显示">
					<template slot-scope="scope">
						<span v-if="scope.row.showMenu">是</span>
						<span v-else>否</span>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination background layout="total, prev, pager, next" :current-page="query.pageIndex" :page-size="query.pageRows"
							   :total="total" @current-change="handlePageChange" prev-click="pageChange(1)" next-click="pageChange(2)"></el-pagination>
			</div>
		</div>
		<el-dialog :title="editType==0?'新增菜单':'修改菜单'" :visible.sync="showEdit" :close-on-click-modal=false width="30%">
			<sys-menu-edit :menu-add="menuAdd" :edit-type="editType" :add-level="addLevel" @submit="saveOrUpdate" @cancel="showEdit=false"></sys-menu-edit>
		</el-dialog>
	</div>
</template>

<script>
import SysMenuEdit from './SysMenuEdit';
export default {
	components: { SysMenuEdit },
	data: function() {
		return {
			menus: [],
			props: {
				label: 'name',
				children: 'children',
				isLeaf: 'isParent'
			},
			query: {
				sysId:null,
				level:null,
				parentId:'',
				pageIndex: 1,
				pageRows: 10
			},
			queryMenus:[],
			pages: 0,
			total:0,
			showEdit: false,
			editType: 0, //0添加 1修改
			parent:'',
			menuAdd:{}
		}
	},
	created() {
		this.init()
	},
	computed:{
		addLevel(){
			if (!this.parent){
				return 0;
			}
			return this.parent.type==1?1:this.parent.level+1
		}
	},
	comments:{
		SysMenuEdit
	},
	methods:{
		init:function(){
			this.loadMenu()
		},
		initQuery(){
			this.query.pageIndex = 1
			this.pageTotal = 0;
		},
		loadMenu(){
			this.HTTP.get('/system/menu/tree').then(res=>{
				if (res.data.success){
					this.menus = res.data.rows;
				}
			})
		},
		refreshTree(){
			this.init();
		},
		handleNodeClick(node){
			debugger
			if (node.type==1){
				this.query.sysId = node.id.substring(1);
				this.query.parentId = null
				this.query.level = 1;
			}else{
				this.query.sysId = null
				this.query.parentId = node.id
				this.query.level = null;
			}
			this.parent = node
			console.log(this.parent)
			this.initQuery()
			this.search()
		},
		search:function(){

			this.HTTP.post('/system/menu/queryPage',this.query).then(res => {
				if (res.data.code == 1) {
					this.queryMenus = res.data.rows
					this.total = res.data.counts
				}
			}).catch(err => {
				console.log(err)
			})
		},
		add:function(){
			if(!this.parent){
				this.$message.error("请选择上级节点")
				return;
			}
			this.menuAdd = {
				sysId:this.parent.type==1?this.parent.id.substring(1):null,
				parentId:this.parent.type==1?0:this.parent.id,
				parentName:this.parent.name,
				level:this.addLevel
			}
			this.showEdit = true
			this.editType = 0
		},
		del:function(){
			if(!this.parent){
				this.$message({
				          message: '请选择需要删除的选项',
				          type: 'warning'
				        });
				return;
			}
			
			this.menuAdd = this.parent
			this.$alert('请确定是否删除菜单:'+this.menuAdd.name, '确定删除', {
			          confirmButtonText: '确定',
			          callback: action => {
			            this.menuAdd.isValid = false
						this.saveOrUpdate()
			          }
			        });
		},
		edit:function(){
			if(!this.parent){
				this.$message({
				          message: '请选择菜单进行修改',
				          type: 'warning'
				        });
				return;
			}
			this.menuAdd = this.parent
			this.showEdit = true
			this.editType = 1
		},
		saveOrUpdate:function(){
			debugger
			this.HTTP.post("/system/menu/saveOrUpdate",this.menuAdd).then(res => {
					if (res.data.code == 1) {
						this.$message.success("更新成功");
						this.search()
					}else{
						this.$message.error(res.data.message);
					}
					this.showEdit = false
					this.parent = null
				}).catch(err => {
					console.log(err)
				})
		},
		handleCurrentChange:function(row){
			this.parent = row
		},
		handlePageChange: function(e) {
			this.query.pageIndex = e
			this.search()
		},
		pageChange: function(type) {
			if (type == 1) {
				this.query.pageIndex -= 1;
			} else {
				this.query.pageIndex += 1;
			}
			this.search()
		},
		
	}
	
}
</script>

<style scoped>
.container *{
	box-sizing: border-box;
}
.container{
	height: 100%;
	width: 100%;
	display: flex;
	justify-content: space-between;
}
.tree-container{
	width: 20%;
	height: 100%;
	overflow-y: scroll;
	overflow-x: scroll;
	padding: 0.5rem;
}
.edit-container{
	width: 80%;
	height: 100%;
	padding: 0.5rem;
}
</style>
